<mat-form-field
  appearance="outline"
  [subscriptSizing]="subscriptSizing()"
  class="w-full">
  <mat-label>{{ label() }}</mat-label>
  <mat-select
    [formControl]="employeesControl"
    (opened)="onPanelOpened()"
    (closed)="onPanelClosed()"
    [hideSingleSelectionIndicator]="hideSingleSelectionIndicator()"
    panelClass="qaroni-filter-panel"
    [multiple]="multiple()">
    @if (multiple()) {
      <mat-select-trigger>{{ selectionSummary }}</mat-select-trigger>
    }

    <div class="select-search-container">
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        class="search-field w-full">
        <input
          matInput
          [formControl]="searchControl"
          placeholder="Buscar..."
          i18n-placeholder
          (keydown)="$event.stopPropagation()"
          (click)="$event.stopPropagation()"
          autocomplete="off" />
      </mat-form-field>

      @if (multiple()) {
        <div class="pt-2 text-xs text-neutral-60">
          {{ selectedIds.length }}
          <ng-container i18n>de</ng-container>
          {{ employees().length }}
          <ng-container i18n>seleccionados</ng-container>
        </div>
      }
    </div>

    @if (multiple()) {
      <ng-container [ngTemplateOutlet]="TSelectAll" />
    }

    @for (employee of matchingEmployees; track employee.employeeId) {
      <mat-option [value]="employee.employeeId">
        {{ employee.firstName }} {{ employee.lastName }}
      </mat-option>
    }

    @if (filterNoResults) {
      <div class="flex items-center justify-center p-5 text-sm text-gray-400">
        @if (hasSearch) {
          <span>
            <ng-container i18n>
              No se encontró ningún empleado con
            </ng-container>
            "{{ searchTerm }}"
          </span>
        } @else {
          <ng-container i18n>No se encontraron resultados</ng-container>
        }
      </div>
    }

    @if (selectedEmployees.length) {
      @if (multiple()) {
        <mat-divider />
        <div class="px-4 pb-1 pt-3 text-xs font-semibold text-neutral-60">
          <ng-container i18n>Seleccionados</ng-container>
          ({{ selectedEmployees.length }})
        </div>
      }

      @for (employee of selectedEmployees; track employee.employeeId) {
        <mat-option [value]="employee.employeeId">
          {{ employee.firstName }} {{ employee.lastName }}
        </mat-option>
      }
    }

    @for (employee of hiddenEmployees; track employee.employeeId) {
      <mat-option [value]="employee.employeeId" class="hidden">
        {{ employee.firstName }} {{ employee.lastName }}
      </mat-option>
    }
  </mat-select>
  @if (InputValidation.checkInputErrors(employeesControl)) {
    <mat-error align="start">
      <qaroni-input-error-messages [fc]="employeesControl" />
    </mat-error>
  }
</mat-form-field>

<ng-template #TSelectAll>
  <mat-option (click)="toggleSelectAll()" [disabled]="filterNoResults">
    <mat-pseudo-checkbox class="mat-option-pseudo-checkbox" [state]="status" />
    <span [ngClass]="{ 'text-black': status === 'unchecked' }">{{
      textSelectAllOption
    }}</span>
  </mat-option>
</ng-template>
